module.exports = __webpack_public_path__ + "img/_1.2bc83ca4.png";